import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {AuthenticationNs, TokenNs} from "@shared/types";
import {useAuthStore} from "@domains/auth/stores/auth.store";
import {useUserStore} from "@shared/stores/user.store";
import {toast} from '@shared/ms-components'

export const oauthSocialCallbackResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    const error = to.query.error;
    const accessToken = to.query.access_token;
    const refreshToken = to.query.refresh_token;
    if (error) {
        
        toast.error(error as string);
    }
    if (!accessToken || !refreshToken) {
        next({name: AuthenticationNs.AuthenticationRouteEnums.SignIn});
    } else {
        const tokenData = {
            access_token: accessToken,
            refresh_token: refreshToken,
            token_type: "bearer",
            expires_in: 5999,
            scope: "read,write"
        } as TokenNs.CreateTokenResponse;

        const authStore = useAuthStore();
        const userStore = useUserStore();
        authStore.setToken(tokenData);
        userStore.getUserMe().then(() => {
            next({name: AuthenticationNs.AuthenticationRouteEnums.ExistingWorkspaces, query: {goToCreateWs: true}});
        });
    }
}
